import { render, staticRenderFns } from "./ui-drag-li.vue?vue&type=template&id=6625991c&scoped=true&"
import script from "./ui-drag-li.vue?vue&type=script&lang=ts&"
export * from "./ui-drag-li.vue?vue&type=script&lang=ts&"
import style0 from "./ui-drag-li.vue?vue&type=style&index=0&id=6625991c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625991c",
  null
  
)

export default component.exports